export const OUTCOMES = [
  ["served", "Served"],
  ["unsuccessful", "Unsuccessful Attempt"],
  ["bad_address", "Bad Address"],
  ["non_service", "Non-Service"],
  ["posted", "Posted"],
];

export const OUTCOME_LABEL = {
  served: "Served", unsuccessful: "Unsuccessful Attempt", bad_address: "Bad Address", non_service: "Non-Service", posted: "Posted",
  not_home: "Not Home", refused: "Refused", moved: "Moved", other: "Other",
};

export const SERVICE_TYPES = [
  "Personal - Abode", "Personal - Workplace", "Substitute - Abode", "Substitute - Workplace", "Substitute - Authorized",
  "Posting", "Drop Service", "Registered Agent", "Secretary of State", "State Agency", "Government Agency",
  "Corporation", "Business", "Certified Mailing", "Other",
];

export const isServed = (o) => o === "served" || o === "posted";
export const outcomeText = (a) => (a.outcome === "other" && a.outcome_other ? `Other — ${a.outcome_other}` : OUTCOME_LABEL[a.outcome] || a.outcome);
export const serviceTypeText = (a) => (a.service_type === "Other" && a.service_type_other ? a.service_type_other : a.service_type || "");
